<div class="d-flex flex-row align-items-center flex-wrap">
  <div class="mb-3">
    <div class="input-group">
      <input class="form-control"
             type="text"
             placeholder="{{ placeholder() }}"
             id="{{ name() }}"
             name="{{ name() }}"
             [(ngModel)]="inputDate"
             required
             [markDisabled]="isDisabledDate"
             [disabled]="isDisabled()"
             ngbDatepicker
             #startDate="ngbDatepicker"
             #model="ngModel">
      <button [disabled]="isDisabled()"
              class="btn btn-outline-secondary"
              (click)="startDate.toggle()" type="button">
        <i class="fa fa-calendar-alt"></i>
      </button>
    </div>
  </div>
</div>
@if (model.errors && model.touched) {
  <div class="form-error-message">
    @if (model.errors.required) {
      <p>{{ placeholder() }} is required</p>
    }
  </div>
}
